export default __webpack_public_path__ + "static/media/Temperatura.ca1242d3.svg";